import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import AOS from 'aos';
import 'aos/dist/aos.css';
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import { IoMdAlert, IoMdCheckmarkCircleOutline, IoMdDocument } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneService from "./OneService";
import { TbDeviceCctv } from "react-icons/tb";
import { FaGun, FaPeopleGroup } from "react-icons/fa6";
import { MdCorporateFare } from "react-icons/md";


export default function ServicesBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: false });
    AOS.refresh(); // optional: refresh if content changes dynamically
  }, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-background"
				style={{
					paddingBottom: "50px",
				}}
			>
				<div 
					className="container pt-5"
					
				>
					
					<div className="row">

						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Our Services
							</h6>
							<h6
								className="text-dim pb-3"
							>
								Our focus is on environmental protection and climate change advocacy, women and youth empowerment, and sustainable agriculture.
							</h6>
						</div>

						<OneService
							image={banner4}
							title="COMPANY REGISTRATION"
							description="Expert guidance and support to register your company or business name efficiently, ensuring full compliance with local regulations."
							navToLink={{
								item: "services",
								subItem: "registration"
							}}
						/>

						<OneService
							image={banner6}
							title="FINANCE AND TAX CONSULTATION"
							description="Strategic advisory services to optimize financial management, tax planning, and compliance for your business."
							navToLink={{
								item: "services",
								subItem: "consultation"
							}}
						/>

						<OneService
							image={banner3}
							title="BOT REGISTRATION"
							description="Assistance in registering microfinance and credit entities with the Bank of Tanzania, ensuring regulatory adherence and operational readiness."
							navToLink={{
								item: "services",
								subItem: "BOT"
							}}
						/>
 
						<OneService
							image={banner5}
							title="GENERAL SUPPLY SOLUTIONS"
							description="Provision of quality goods and materials tailored to meet the needs of businesses across various industries."
							navToLink={{
								item: "services",
								subItem: "supply"
							}} 
						/>

					</div>
				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
